import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d89eb87"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "categorySetting" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "hidden" }, "카테고리", -1))
const _hoisted_3 = { class: "category-subject" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "sub-title" }, "진료과목", -1))
const _hoisted_5 = { class: "select-subject selectbox" }
const _hoisted_6 = { class: "option-list-wrap mb10 relative-parent" }
const _hoisted_7 = {
  key: 0,
  class: "list-exception-layer mb10"
}
const _hoisted_8 = { class: "msg" }
const _hoisted_9 = {
  key: 0,
  class: "list-loading-layer"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-loading" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "dots" }, [
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "msg" }, "조회중..")
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "cd-kr" }
const _hoisted_14 = { class: "txt-wrap" }
const _hoisted_15 = { class: "code-subject" }
const _hoisted_16 = { class: "en-ru" }
const _hoisted_17 = { class: "txt-wrap" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lang" }, "EN", -1))
const _hoisted_19 = { class: "txt-wrap" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lang" }, "RU", -1))
const _hoisted_21 = { class: "checkbox-wrap" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "btn-wrap" }
const _hoisted_24 = { class: "select-disease-on-subject" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "sub-title" }, "하위 진료질환", -1))
const _hoisted_26 = { class: "selectbox" }
const _hoisted_27 = { class: "option-list-wrap mb10 relative-parent" }
const _hoisted_28 = {
  key: 0,
  class: "list-exception-layer mb10"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "msg" }, "진료과목을 선택해 주세요.", -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  class: "list-exception-layer mb10"
}
const _hoisted_32 = { class: "msg" }
const _hoisted_33 = {
  key: 2,
  class: "list-loading-layer"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-loading" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "dots" }, [
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "msg" }, "조회중..")
], -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "cd-kr" }
const _hoisted_37 = { class: "txt-wrap" }
const _hoisted_38 = { class: "code-disease" }
const _hoisted_39 = { class: "en-ru" }
const _hoisted_40 = { class: "txt-wrap" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lang" }, "EN", -1))
const _hoisted_42 = { class: "txt-wrap" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lang" }, "RU", -1))
const _hoisted_44 = { class: "checkbox-wrap" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "btn-wrap" }
const _hoisted_47 = { class: "category-disease" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "sub-title" }, "전체 진료질환", -1))
const _hoisted_49 = { class: "selectbox" }
const _hoisted_50 = { class: "option-list-wrap mb10 relative-parent" }
const _hoisted_51 = {
  key: 0,
  class: "list-exception-layer mb10"
}
const _hoisted_52 = { class: "msg" }
const _hoisted_53 = {
  key: 1,
  class: "list-loading-layer"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-loading" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "dots" }, [
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "msg" }, "조회중..")
], -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = { class: "cd-kr" }
const _hoisted_57 = { class: "txt-wrap" }
const _hoisted_58 = { class: "code-disease" }
const _hoisted_59 = { class: "en-ru" }
const _hoisted_60 = { class: "txt-wrap" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lang" }, "EN", -1))
const _hoisted_62 = { class: "txt-wrap" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lang" }, "RU", -1))
const _hoisted_64 = { class: "checkbox-wrap" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "arrow-add" }, null, -1))
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = { class: "btn-wrap" }
const _hoisted_69 = {
  key: 0,
  class: "currentPopup"
}
const _hoisted_70 = {
  key: 0,
  class: "resultPopup"
}

import { onMounted, onUpdated, watch } from 'vue';
import { useStore } from 'vuex';
import { computed, ref } from '@vue/reactivity';
import ConnectPopup from './popup/ConnectPopup.vue';
import SubjectPopup from './popup/SubjectPopup.vue';
import DiseasePopup from './popup/DiseasePopup.vue';
import ConfirmPopup from '@/components/popup/ConfirmPopup.vue';
import ExceptionPopup from '@/components/popup/ExceptionPopup.vue';
import ResultPopup from '@/components/popup/ResultPopup.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'CategorySetting',
  setup(__props) {

const store = useStore();
const Set = store.state.moduleSet;
/**** popup ------------------- */
var currentPopup = ref(null);
var popupTitle = ref('');
var popupDesc = ref('');
var popupVersion = ref(''); // 진료과목 or 진료질환 00: 추가, 01: 수정
var exception = computed(() => Set.exception);
var result = computed(() => Set.result);
var resultTitle = computed(() => Set.result.title);
var resultDesc = computed(() => Set.result.desc);
let onCallMethod = () => {
  return console.log('on call');
};
const close_currentPopup = () => {
  currentPopup.value = null;
};
const close_resultPopup = () => {
  store.commit('moduleSet/reset_result', { root: true });
};
const onClick_cancel = () => {
  close_currentPopup();
};
const onClick_close = () => {
  close_currentPopup();
};
const onClick_confirm = async () => {
  close_currentPopup();
  onCallMethod();
};
/**** data -------------------- */
var subjects = computed(() => Set.subjects);
var diseases_onSubject = computed(() => Set.diseases_onSubject);
var diseases_all = computed(() => Set.diseases_all);
var updatedCode_subject = ref('');
var updatedCode_diseases_onSubject = ref([]);
var updatedCode_disease_all = ref('');
var isOn_subject = ref(false);
var isOn_subjects = ref([]);
var isOnLoading_subjects = ref(true);
var isOnLoading_diseases_onSubject = ref(false);
var isOnLoading_diseases_all = ref(true);
var selectedSubject = ref(null);
var selectedSubjectIndex = ref(null);
var checkedSubjects = computed(() => store.getters['moduleSet/getCheckedSubjects']);
var checkedDiseases_onSubject = computed(() => store.getters['moduleSet/getCheckedDiseases_onSubject']);
var checkedDiseases_all = computed(() => store.getters['moduleSet/getCheckedDiseases_all']);
/**** methods ----------------- */
const resetSubjects_onStyle = async () => {
  isOn_subjects.value = [];
  for (let i = 0; i < subjects.value.length; i++) {
    isOn_subjects.value.push(false);
  }
};
const resetDiseases_onSubject = () => {
  store.commit('moduleSet/resetDiseases_onSubject', { root: true });
};
const onClick_subject = async (item, index) => {
  updatedCode_diseases_onSubject.value = [];
  //Set.newDiseases_onSubject_code = null;
  // console.log(item);
  if (isOn_subjects.value[index]) {
    selectedSubject.value = null;
    //해제
    isOn_subjects.value[index] = false;
    isOn_subject.value = false;
    store.commit('moduleSet/resetDiseases_onSubject', { root: true });
  } else {
    // 선택
    isOnLoading_diseases_onSubject.value = true;
    selectedSubject.value = item;
    selectedSubjectIndex.value = index; // 하위 진료질환 연결 후 리스트 셋업시 필요
    selectedSubject.value.code = await item.code;
    await resetSubjects_onStyle();
    isOn_subject.value = await true;
    await store.commit('moduleSet/resetDiseases_onSubject', { root: true });
    isOn_subjects.value[index] = await true;
    await setDiseases_onSubject(item.code);
  }
};
const check_subject = async (index: number) => {
  if (Set.subjects[index].isChecked) {
    store.commit('moduleSet/uncheck_subject', index, { root: true });
  } else {
    store.commit('moduleSet/check_subject', index, { root: true });
  }
};
const uncheck_subjects = async () => {
  store.commit('moduleSet/uncheck_subjects', { root: true });
};
const check_disease_onSubject = async (index: number) => {
  if (Set.diseases_onSubject[index].isChecked) {
    store.commit('moduleSet/uncheck_disease_onSubject', index, { root: true });
  } else {
    store.commit('moduleSet/check_disease_onSubject', index, { root: true });
  }
};
const check_disease_all = async (index: number) => {
  if (Set.diseases_all[index].isChecked) {
    store.commit('moduleSet/uncheck_disease_all', index, { root: true });
  } else {
    store.commit('moduleSet/check_disease_all', index, { root: true });
  }
};
const uncheck_diseases_all = async () => {
  store.commit('moduleSet/uncheck_diseases_all', { root: true });
};
const onClick_delete_subjects = () => {
  // delete array
  popupTitle.value = '진료과목 삭제';
  if (checkedSubjects.value.length === 0 || checkedSubjects.value.length === undefined) {
    popupDesc.value = '삭제할 진료과목을 선택해 주세요.';
    currentPopup.value = ExceptionPopup;
  } else {
    onCallMethod = delete_subjects;
    if (checkedSubjects.value.length === 1) {
      popupDesc.value = `${checkedSubjects.value[0].nameKr} 1개 진료과목을 삭제합니다.`;
      currentPopup.value = ConfirmPopup;
    } else {
      popupDesc.value = `${checkedSubjects.value[0].nameKr} 외 ${checkedSubjects.value.length - 1} 개 진료과목을 삭제합니다.`;
      currentPopup.value = ConfirmPopup;
    }
  }
};
const onClick_modify_subject = () => {
  // modify item
  popupTitle.value = '진료과목 수정';
  if (checkedSubjects.value.length === 0) {
    popupDesc.value = '수정할 진료과목을 선택해 주세요.';
    currentPopup.value = ExceptionPopup;
  } else if (checkedSubjects.value.length !== 1) {
    popupDesc.value = '진료과목을 하나만 선택해 주세요.';
    currentPopup.value = ExceptionPopup;
  } else {
    popupVersion.value = '01';
    currentPopup.value = SubjectPopup;
  }
};
const onClick_addNew_subject = () => {
  // add new item
  addNew_subject();
};
const onClick_disconnect_diseases_onSubject = () => {
  updatedCode_diseases_onSubject.value = [];
  // delete array
  popupTitle.value = '하위 진료질환 삭제';
  if (selectedSubject.value === null || selectedSubject.value == undefined) {
    popupDesc.value = '진료과목을 먼저 선택해 주세요.';
    currentPopup.value = ExceptionPopup;
  } else {
    if (checkedDiseases_onSubject.value.length === 0 || checkedDiseases_onSubject.value.length === undefined) {
      popupDesc.value = '삭제할 하위 진료질환을 선택해 주세요.';
      currentPopup.value = ExceptionPopup;
    } else {
      onCallMethod = disconnect_disease_onSubject;
      if (checkedDiseases_onSubject.value.length === 1) {
        popupDesc.value = `${selectedSubject.value.nameKr}에서 ${checkedDiseases_onSubject.value[0].nameKr} 1개 질환을 삭제합니다.`;
        currentPopup.value = ConfirmPopup;
      } else {
        popupDesc.value = `${selectedSubject.value.nameKr}에서 ${checkedDiseases_onSubject.value[0].nameKr} 외 ${
          checkedDiseases_onSubject.value.length - 1
        } 개 하위 진료질환을 삭제합니다.`;
        currentPopup.value = ConfirmPopup;
      }
    }
  }
};
const onClick_delete_diseases_all = () => {
  // delete array
  popupTitle.value = '진료질환 삭제';
  if (checkedDiseases_all.value.length === 0 || checkedDiseases_all.value.length === undefined) {
    popupDesc.value = '삭제할 진료질환을 선택해 주세요.';
    currentPopup.value = ExceptionPopup;
  } else {
    onCallMethod = delete_diseases_all;
    if (checkedDiseases_all.value.length === 1) {
      popupDesc.value = `${checkedDiseases_all.value[0].nameKr} 1개 진료질환을 삭제합니다.`;
      currentPopup.value = ConfirmPopup;
    } else {
      popupDesc.value = `${checkedDiseases_all.value[0].nameKr} 외 ${checkedDiseases_all.value.length - 1} 개 진료질환을 삭제합니다.`;
      currentPopup.value = ConfirmPopup;
    }
  }
};
const onClick_modify_disease_all = () => {
  // modify item
  popupTitle.value = '진료질환 수정';
  if (checkedDiseases_all.value.length === 0) {
    popupDesc.value = '수정할 진료질환을 선택해 주세요.';
    currentPopup.value = ExceptionPopup;
  } else if (checkedDiseases_all.value.length !== 1) {
    popupDesc.value = '진료질환을 하나만 선택해 주세요.';
    currentPopup.value = ExceptionPopup;
  } else {
    popupVersion.value = '01';
    currentPopup.value = DiseasePopup;
  }
};
const onClick_addNew_disease_all = () => {
  // add new item
  addNew_disease_all();
};
var onClick_connect_diseases_onSubject = () => {
  // connect array
  if (selectedSubject.value === null || selectedSubject.value === undefined) {
    popupTitle.value = '하위 진료질환 추가';
    popupDesc.value = '진료과목을 선택해 주세요.';
    currentPopup.value = ExceptionPopup;
  } else {
    onCallMethod = connect_diseases_onSubject;
    // console.log(onCallMethod);
    if (checkedDiseases_all.value.length < 1) {
      popupTitle.value = '하위 진료질환 추가';
      popupDesc.value = `'${selectedSubject.value.nameKr}'에 추가할 진료질환을 선택해 주세요.`;
      currentPopup.value = ExceptionPopup;
    } else {
      popupTitle.value = '하위 진료질환 추가';
      popupDesc.value = ``;
      currentPopup.value = ConnectPopup;
    }
  }
};
/** 01. 진료질환 item 등록 */
const addNew_disease_all = async () => {
  popupTitle.value = '새 진료질환 추가';
  popupVersion.value = '00';
  currentPopup.value = DiseasePopup;
};
/** 02. 전체 진료질환 array 삭제  */
const delete_diseases_all = async () => {
  popupTitle.value = '진료질환 삭제';
  let codes = [];
  for (let i = 0; i < checkedDiseases_all.value.length; i++) {
    codes.push(checkedDiseases_all.value[i].code);
  }
  store.dispatch('moduleSet/delete_diseases_all', codes, { root: true });
};
/** 03. 하위 / 전체 진료질환 list 조회 */
const setDiseases_onSubject = async (subjectCode: string) => {
  isOnLoading_diseases_onSubject.value = true;
  // console.log(subjectCode);
  await store.dispatch('moduleSet/getDiseases', subjectCode, { root: true });
  setTimeout(() => {
    isOnLoading_diseases_onSubject.value = false;
  }, 400);
  // setTimeout(() => {
  //   updatedCode_diseases_onSubject.value = [];
  // }, 2000);
};
/** 03-1. 전체 진료질환 list 조회 */
const setDiseases_all = async () => {
  isOnLoading_diseases_all.value = true;
  let subjectCode = await '';
  await store.dispatch('moduleSet/getDiseases', subjectCode, { root: true });
  await uncheck_diseases_all();
  setTimeout(() => {
    isOnLoading_diseases_all.value = false;
  }, 400);
};
/** 04. 진료질환 item 수정 */
const modify_disease_all = async () => {
  let code = checkedDiseases_all.value[0].code;
  store.dispatch('moduleSet/modify_disease_all', code, { root: true });
};
/** 05. 진료과목에 하위 진료질환 array 연결 */
const connect_diseases_onSubject = async () => {
  let codeData = {};
  let dCodes = [];
  for (let i = 0; i < checkedDiseases_all.value.length; i++) {
    dCodes.push(checkedDiseases_all.value[i].code);
  }
  codeData = await {
    subjectCode: selectedSubject.value.code,
    diseasesCode: dCodes,
  };
  // console.log(codeData);
  await store.dispatch('moduleSet/connect_diseases_onSubject', codeData, { root: true });
  updatedCode_diseases_onSubject.value = await Set.newDiseases_onSubject_code;
};
/** 06. 진료과목에서 하위 진료질환 array 삭제 */
const disconnect_disease_onSubject = async () => {
  let codeData = {};
  let dCodes = [];
  for (let i = 0; i < checkedDiseases_onSubject.value.length; i++) {
    dCodes.push(checkedDiseases_onSubject.value[i].code);
  }
  codeData = await {
    subjectCode: selectedSubject.value.code,
    diseasesCode: dCodes,
  };
  // console.log(codeData);
  await store.dispatch('moduleSet/disconnect_diseases_onSubject', codeData, { root: true });
};
/** 07. 진료과목 item 등록 */
const addNew_subject = async () => {
  popupTitle.value = '새 진료과목 추가';
  popupVersion.value = '00';
  currentPopup.value = SubjectPopup;
  resetSubjects_onStyle();
};
/** 08. 진료과목 array 삭제 */
const delete_subjects = async () => {
  let codes = [];
  for (let i = 0; i < checkedSubjects.value.length; i++) {
    codes.push(checkedSubjects.value[i].code);
  }
  store.dispatch('moduleSet/delete_subjects', codes, { root: true });
};
/** 09. 진료과목 list 조회 */
const setSubjects = async () => {
  isOnLoading_subjects.value = true;
  await store.dispatch('moduleSet/getSubjects', { root: true });
  await uncheck_subjects();
  await resetSubjects_onStyle();
  setTimeout(() => {
    isOnLoading_subjects.value = false;
  }, 400);
};
/** 10. 진료과목 item 수정 */
const modify_subject = async () => {
  let code = checkedSubjects.value[0].code;
  store.dispatch('moduleSet/modify_subject', code, { root: true });
};

/**** content -----------------
 *
 * 카테고리 관리
 * /
 * | 진료과목
 * 01. 삭제
 * 02. 수정
 * 03. 추가
 * /
 * | 하위 진료질환
 * 01. 삭제
 * /
 * | 진료질환 목록
 * 00. 진료과목에 진료질환 추가
 * 01. 삭제
 * 02. 수정
 * 03. 추가
 * /
 */

/**
 * submit [1]
 */
/**
 * submit [2] 한국어, 러시아어
 */
/**** hook -------------------- */
onMounted(() => {
  setSubjects();
  setDiseases_all();
});
watch(
  () => result.value.bool,
  async (newValue, oldValue) => {
    if (oldValue === true && newValue === false) {
      await setSubjects();
      await setDiseases_all();
      if (selectedSubject.value !== null) {
        onClick_subject(selectedSubject.value, selectedSubjectIndex.value);
      }
    }
  },
  { deep: true }
);
watch(
  () => subjects.value,
  async (newValue, oldValue) => {
    let target = document.getElementById('subjectsScroll');
    let newLeng = newValue.length;
    let oldLeng = oldValue.length;
    if (newLeng - 1 === oldLeng) {
      updatedCode_subject.value = Set.newSubject_code;
      setTimeout(() => {
        if (target !== null) {
          target.scrollIntoView(false);
        }
      }, 200);
      selectedSubject.value = null;
      selectedSubjectIndex.value = null;
      resetDiseases_onSubject();
    } else {
      updatedCode_subject.value = '';
    }
  },
  { deep: true }
);
watch(
  () => selectedSubject.value,
  async (newValue, oldValue) => {
    if (newValue === null) {
      isOn_subject.value = false;
    }
  },
  { deep: true }
);
watch(
  () => diseases_all.value,
  async (newValue, oldValue) => {
    let target = document.getElementById('diseases_allScroll');
    let newLeng = newValue.length;
    let oldLeng = oldValue.length;
    if (newLeng - 1 === oldLeng) {
      updatedCode_disease_all.value = Set.newDisease_all_code;
      setTimeout(() => {
        if (target !== null) {
          target.scrollIntoView(false);
        }
      }, 200);
    } else {
      updatedCode_disease_all.value = '';
    }
  },
  { deep: true }
);
watch(
  () => Set.newDiseases_onSubject_code,
  async (newValue, oldValue) => {
    let target = document.getElementById('diseases_onSubjectScroll');
    let newLeng = newValue.length;
    let oldLeng = oldValue.length;
    if (newLeng !== oldLeng) {
      updatedCode_diseases_onSubject.value = await Set.newDiseases_onSubject_code;
      setTimeout(() => {
        if (target !== null) {
          target.scrollIntoView(false);
        }
      }, 200);
    }
  },
  { deep: true }
);
// watch(
//   () => Set.newDiseases_onSubject_code,
//   async (newValue, oldValue) => {
//     let target = document.getElementById('diseases_onSubjectScroll');
//     updatedCode_diseases_onSubject.value = Set.newDiseases_onSubject_code;
//     setTimeout(() => {
//       if (target !== null) {
//         target.scrollIntoView(false);
//       }
//     }, 400);
//   },
//   { deep: true }
// );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_unref(exception).subjects.bool)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(exception).subjects.desc), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_Transition, { name: "listLoadigLayer" }, {
            default: _withCtx(() => [
              (_unref(isOnLoading_subjects))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_TransitionGroup, {
            id: "subjectsScroll",
            tag: "ul",
            class: "option-list",
            name: "subjectsItem"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subjects), (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass([{ on: _unref(isOn_subjects)[index] }, { new: _unref(updatedCode_subject) === item.code }]),
                  key: item,
                  onClick: ($event: any) => (onClick_subject(item, index))
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("p", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(item.code), 1),
                      _createTextVNode(_toDisplayString(item.nameKr), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("p", _hoisted_17, [
                      _hoisted_18,
                      _createTextVNode(_toDisplayString(item.nameEn), 1)
                    ]),
                    _createElementVNode("p", _hoisted_19, [
                      _hoisted_20,
                      _createTextVNode(_toDisplayString(item.nameRu), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["checkbox checkbox-all", [{ 'checked-sub1': item.isChecked === true }, { unchecked: item.isChecked === false }]]),
                      onClick: _withModifiers(($event: any) => (check_subject(index)), ["stop"])
                    }, null, 10, _hoisted_22)
                  ])
                ], 10, _hoisted_12))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("button", {
          class: "btn-delete",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick_delete_subjects()))
        }, "삭제"),
        _createElementVNode("button", {
          class: "btn-modify",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onClick_modify_subject()))
        }, "수정"),
        _createElementVNode("button", {
          class: "btn-add-new",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (onClick_addNew_subject()))
        }, "추가")
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            (!_unref(isOn_subject))
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
              : _createCommentVNode("", true),
            (_unref(exception).diseases_onSubject.bool)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(exception).diseases_onSubject.desc), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(isOnLoading_diseases_onSubject))
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
              : _createCommentVNode("", true),
            _createVNode(_TransitionGroup, {
              id: "diseases_onSubjectScroll",
              tag: "ul",
              class: "option-list",
              name: "diseaseOnSubjectsItem"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(diseases_onSubject), (item, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: item }, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("p", _hoisted_37, [
                        _createElementVNode("span", _hoisted_38, _toDisplayString(item.code), 1),
                        _createTextVNode(_toDisplayString(item.nameKr), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("p", _hoisted_40, [
                        _hoisted_41,
                        _createTextVNode(_toDisplayString(item.nameEn), 1)
                      ]),
                      _createElementVNode("p", _hoisted_42, [
                        _hoisted_43,
                        _createTextVNode(_toDisplayString(item.nameRu), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["checkbox", [{ 'checked-main': item.isChecked === true }, { unchecked: item.isChecked === false }]]),
                        onClick: _withModifiers(($event: any) => (check_disease_onSubject(index)), ["stop"])
                      }, null, 10, _hoisted_45)
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("button", {
            class: "btn-delete",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (onClick_disconnect_diseases_onSubject()))
          }, "삭제")
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_47, [
      _hoisted_48,
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, [
          (_unref(exception).diseases_all.bool)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _createElementVNode("span", _hoisted_52, _toDisplayString(_unref(exception).diseases_all.desc), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(isOnLoading_diseases_all))
            ? (_openBlock(), _createElementBlock("div", _hoisted_53, _hoisted_55))
            : _createCommentVNode("", true),
          _createVNode(_TransitionGroup, {
            id: "diseases_allScroll",
            tag: "ul",
            class: "option-list",
            name: "diseasesAllItem"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(diseases_all), (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item,
                  class: _normalizeClass([{ new: _unref(updatedCode_disease_all) === item.code }])
                }, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("p", _hoisted_57, [
                      _createElementVNode("span", _hoisted_58, _toDisplayString(item.code), 1),
                      _createTextVNode(_toDisplayString(item.nameKr), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("p", _hoisted_60, [
                      _hoisted_61,
                      _createTextVNode(_toDisplayString(item.nameEn), 1)
                    ]),
                    _createElementVNode("p", _hoisted_62, [
                      _hoisted_63,
                      _createTextVNode(_toDisplayString(item.nameRu), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["checkbox", [{ 'checked-main': item.isChecked === true }, { unchecked: item.isChecked === false }]]),
                      onClick: _withModifiers(($event: any) => (check_disease_all(index)), ["stop"])
                    }, null, 10, _hoisted_65)
                  ])
                ], 2))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("button", {
          class: "category-connect",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(onClick_connect_diseases_onSubject)()))
        }, _hoisted_67)
      ]),
      _createElementVNode("div", _hoisted_68, [
        _createElementVNode("button", {
          class: "btn-delete",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (onClick_delete_diseases_all()))
        }, "삭제"),
        _createElementVNode("button", {
          class: "btn-modify",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (onClick_modify_disease_all()))
        }, "수정"),
        _createElementVNode("button", {
          class: "btn-add-new",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (onClick_addNew_disease_all()))
        }, "추가")
      ])
    ]),
    _createVNode(_Transition, { name: "currentPopup" }, {
      default: _withCtx(() => [
        (_unref(currentPopup) !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentPopup)), {
                "popup-title": _unref(popupTitle),
                "popup-desc": _unref(popupDesc),
                "popup-version": _unref(popupVersion),
                "selected-subject": _unref(selectedSubject),
                "checked-subject": _unref(checkedSubjects)[0],
                "checked-disease_all": _unref(checkedDiseases_all)[0],
                "checked-diseases_all": _unref(checkedDiseases_all),
                onOnClick_close: _cache[8] || (_cache[8] = ($event: any) => (onClick_close())),
                onOnClick_cancel: _cache[9] || (_cache[9] = ($event: any) => (onClick_cancel())),
                onOnClick_confirm: _cache[10] || (_cache[10] = ($event: any) => (onClick_confirm()))
              }, null, 40, ["popup-title", "popup-desc", "popup-version", "selected-subject", "checked-subject", "checked-disease_all", "checked-diseases_all"]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "resultPopup" }, {
      default: _withCtx(() => [
        (_unref(result).bool)
          ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
              _createVNode(ResultPopup, {
                "result-title": _unref(resultTitle),
                "result-desc": _unref(resultDesc),
                onOnClick_close: _cache[11] || (_cache[11] = ($event: any) => (close_resultPopup()))
              }, null, 8, ["result-title", "result-desc"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})